import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

// import { Button, FormControlLabel, MenuItem, Radio, Typography } from 'material-ui';
import { InputLabel, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText, Icon, IconButton, Toolbar, AppBar } from 'material-ui';


import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import moment from 'moment';
import 'react-select/dist/react-select.css'
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';



const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});

var accountType = null;
var accountTypeId = null;
var accountCategoryRefNo = null;
var accountCategory = null;
var mainAccountefNo = null;
var mainAccountName = null;
var mainAccountId = null;
var ledgerefNo = null;
var ledgerName = null;
var ledgerCode = null;
var description = null;
var status = null;
var id = null;
var update_id = null;
var is_active = null;

var bankInfoLedgerCode = '';

class LedgerAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            shown: false,
            loading: true,
            shownEdit: false,
            isActive: true,
            isActiveEdit: false,
            iscontrolAccount: false,
            iscontrolAccountEdit: false,
            category_code_disabled: false,
            category_name_disabled: false,
            openComposeDialog: false,
            banks: [],
            accountTypes: [],
            accountCategories: [],
            accountCategoryNames: [],
            mainAccountNames: [],
            mainAccRefs: [],
            records: [],
            accountType: '',
            accountCategory: '',
            accountCategoryName: '',

            mainAccRef: '',
            account_type_id: '',
            main_accounte_id: '',
            mainAccName: '',
            mainAccountId: '',

            mainAccNameValue: '',
            mainAccRefValue: '',

            mainAccNameEdit: '',
            accountTypeNameEdit: '',
            accountTypeEdit: '',
            accountCategoryEdit: '',
            accountCategoryNameEdit: '',
            mainAccRefEdit: '',
            mainAccountNameChange: '',

            mainAccNameEditValue: '',
            mainAccRefEditValue: '',
            accountCategoryEditValue: '',
            accountCategoryNameEditValue: '',

            category_ref_no: '',
            category_ref_no_edit: '',
            main_account_id: '',

            editAccountType: false,
            editCatCode: false,
            editCatName: false,
            editBankName: false,
            editBankRefId: false,
            isNew: false,
            editControllAcc: false,

            ////////////////////////////////////////////// <<start sheyan>> /////////////////////////////////
            // bank information
            openBankInfoDialog: false,
            companyBanks: [],
            companyBank: '',

            companyBankccountNumbers: [],
            companyBankAccount: '',

            // bank detail whare account no
            bankRoutineNo: '',
            branchName: '',
            branchCode: '',
            bankAddress1: '',
            bankAddress2: '',
            country: '',
            state: '',
            city: '',
            zipCode: '',
            accountHolderName: '',
            accTypeBank: false,
            jointAccountHolderName: '',
            isActiveBank: false,

            ledgerAccIdInsereted: '',

            ledgerCode: '',

            /////////////////////////////////////////////////<<end sheyan>>///////////////////////////////
        };

        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
        this.loadData();
        this.loadAccountTypes();
        // this.loadAccountCategory();
        // this.loadMainAccount();

        // bank informaion <<sheyan>>
        this.closeBankInfoDialog = this.closeBankInfoDialog.bind(this);
        this.loadCompanyBank();
    }

    openNewCustomerDialog() {
        // this.setState({ loading: true });
        // this.setState({ expanded: 'panel1' });
        // this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        // this.setState({ loading: false });
    }

    closeNewCustomerDialog() {
        // this.setState({});
        this.form.reset();
        this.setState({
            shown: false,
            iscontrolAccount: false,
            accountType: '',
            accountCategory: '',
            accountCategoryName: '',
            mainAccRef: '',
            mainAccName: '',
            openComposeDialog: false
        });
    }

    loadAccountTypes() {
        var accountTypes = [];
        // axios.get('http://localhost:5009/accountType/getAccountTypes')
        axios.get(window.accountServer + '/accountType/getAccountTypes')
            .then(response => {
                // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
                for (let i = 0; i < response.data.accountTypes.length; i++) {

                    accountTypes.push({
                        value: response.data.accountTypes[i].ID_ACCOUNT_TYPE,
                        label: response.data.accountTypes[i].NAME
                    });
                }
                this.setState({ accountTypes: accountTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadAccountCategory(id) {
        var accountCategories = [];
        var accountCategoryNames = [];
        this.setState({
            accountCategories: [],
            accountCategoryNames: [],
            accountCategoryName: '',
            accountCategoryNameEdit: '',
            accountCategory: '',
            accountCategoryEdit: '',
            mainAccountNames: [],
            mainAccRefs: [],
        });

        const categoryObj = {
            id: id
        }
        // axios.post('http://localhost:5009/accountCategory/getAccountCategoryByType', categoryObj)
        axios.post(window.accountServer + '/accountCategory/getAccountCategoryByType', categoryObj)
            .then(response => {
                // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
                for (let i = 0; i < response.data.accountCategories.length; i++) {

                    accountCategories.push({
                        value: response.data.accountCategories[i].ID_ACCOUNT_CATEGORY,
                        label: response.data.accountCategories[i].ID_ACCOUNT_CATEGORY
                    });
                    accountCategoryNames.push({
                        value: response.data.accountCategories[i].NAME,
                        label: response.data.accountCategories[i].NAME
                    });
                }
                this.setState({
                    accountCategories: accountCategories,
                    accountCategoryNames: accountCategoryNames,
                });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadAccountCategoryRefNo(id) {
        const categoryObj = {
            id: id
        }
        // axios.post('http://localhost:5009/accountCategory/getAccountCategoryRefNoById', categoryObj)
        axios.post(window.accountServer + '/accountCategory/getAccountCategoryRefNoById', categoryObj)
            .then(response => {
                // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
                this.setState({
                    category_ref_no: response.data.accountCategories[0].REFERENCE_NO
                });


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    loadAccountCategoryRefNoEdit(id) {
        const categoryObj = {
            id: id
        }
        // axios.post('http://localhost:5009/accountCategory/getAccountCategoryRefNoById', categoryObj)
        axios.post(window.accountServer + '/accountCategory/getAccountCategoryRefNoById', categoryObj)
            .then(response => {
                // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
                this.setState({
                    category_ref_no_edit: response.data.accountCategories[0].REFERENCE_NO
                });


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    loadMainAccount(categoryId) {
        var mainAccountNames = [];
        var mainAccRefs = [];
        const categoryObj = {
            id: categoryId
        }
        // axios.post('http://localhost:5009/mainAccount/getMainAccountsByCategoryId', categoryObj)
        axios.post(window.accountServer + '/mainAccount/getMainAccountsByCategoryId', categoryObj)
            .then(response => {

                for (let i = 0; i < response.data.mainAccounts.length; i++) {
                    // console.log("rrrr" + JSON.stringify(response.data[i].bank_name));
                    mainAccountNames.push({
                        value: response.data.mainAccounts[i].NAME,
                        label: response.data.mainAccounts[i].NAME
                    });
                    mainAccRefs.push({
                        value: response.data.mainAccounts[i].REFERENCE_NO,
                        label: response.data.mainAccounts[i].REFERENCE_NO
                    });
                }
                this.setState({
                    mainAccountNames: mainAccountNames,
                    mainAccRefs: mainAccRefs,
                });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    handleCloseEdit = () => {
        this.setState({ edit: false });
    };


    handleMainAccountName = (selectedOption) => {
        this.setState({
            mainAccName: selectedOption
        });
        if (selectedOption != null) {
            this.loadMainAccountData(selectedOption.label, "NAME", "SAVE");
            this.setState({
                mainAccNameValue: selectedOption.value
            });
        } else {
            this.setState({
                mainAccRef: '',
                mainAccNameValue: '',
                mainAccRefValue: ''
            });
        }
    }

    handleMainAccountRef = (selectedOption) => {
        this.setState({
            mainAccRef: selectedOption
        });
        if (selectedOption != null) {
            this.loadMainAccountData(selectedOption.value, "CODE", "SAVE");
            this.setState({
                mainAccRefValue: selectedOption.value
            });
        } else {
            this.setState({
                mainAccName: '',
                mainAccNameValue: '',
                mainAccRefValue: ''
            });
        }
    }

    //edit

    handleMainAccountNameEdit = (selectedOption) => {
        this.setState({
            mainAccNameEdit: selectedOption
        });
        if (selectedOption != null) {
            this.loadMainAccountData(selectedOption.label, "NAME", "EDIT");
            this.setState({
                mainAccNameEditValue: selectedOption.value
            });
        } else {
            this.setState({
                mainAccRefEdit: '',
                mainAccNameEditValue: '',
                mainAccRefEditValue: ''
            });
        }
    }

    handleMainAccountRefEdit = (selectedOption) => {
        this.setState({
            mainAccRefEdit: selectedOption
        });
        if (selectedOption != null) {
            this.loadMainAccountData(selectedOption.value, "CODE", "EDIT");
            this.setState({
                mainAccRefEditValue: selectedOption.value
            });
        } else {
            this.setState({
                mainAccNameEdit: '',
                mainAccNameEditValue: '',
                mainAccRefEditValue: ''
            });
        }
    }


    loadMainAccountData(value, type, state) {
        // alert(value)

        if (type == "CODE") {
            const accObj = {
                id: value
            }
            // axios.post('http://localhost:5009/mainAccount/getMainAccountNameByRefId', accObj)
            axios.post(window.accountServer + '/mainAccount/getMainAccountNameByRefId', accObj)
                .then(response => {
                    // alert(response.data.accountCategories[0].NAME)
                    if (state == "SAVE") {
                        this.setState({
                            mainAccName: response.data.mainAccount[0].NAME,
                            mainAccNameValue: response.data.mainAccount[0].NAME,
                            main_account_id: response.data.mainAccount[0].ID_MAIN_ACCOUNT,
                            category_name_disabled: true
                        });
                    } else {
                        // alert(state)
                        this.setState({
                            mainAccNameEdit: response.data.mainAccount[0].NAME,
                            mainAccNameEditValue: response.data.mainAccount[0].NAME,
                            main_account_id: response.data.mainAccount[0].ID_MAIN_ACCOUNT,
                            category_name_disabled: true
                        });
                    }

                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        } else {
            const accObj = {
                name: value
            }
            // axios.post('http://localhost:5009/mainAccount/getMainAccountRefNoByName', accObj)
            axios.post(window.accountServer + '/mainAccount/getMainAccountRefNoByName', accObj)
                .then(response => {

                    // alert(response.data.accountCategories[0].ID_ACCOUNT_CATEGORY)
                    if (state == "SAVE") {
                        this.setState({
                            mainAccRef: response.data.mainAccount[0].REFERENCE_NO,
                            mainAccRefValue: response.data.mainAccount[0].REFERENCE_NO,
                            main_account_id: response.data.mainAccount[0].ID_MAIN_ACCOUNT,
                            category_code_disabled: true
                        });
                    } else {
                        // alert(state)
                        this.setState({
                            mainAccRefEdit: response.data.mainAccount[0].REFERENCE_NO,
                            mainAccRefEditValue: response.data.mainAccount[0].REFERENCE_NO,
                            main_account_id: response.data.mainAccount[0].ID_MAIN_ACCOUNT,
                            category_code_disabled: true
                        });
                    }
                    // this.loadAccountCategoryRefNo(response.data.accountCategories[0].ID_ACCOUNT_CATEGORY)


                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }

    }


    handleAccountCategoryName = (selectedOption) => {

        this.setState({
            accountCategoryName: selectedOption
        });
        if (selectedOption != null) {
            this.loadCategoryData(selectedOption.value, "NAME", "SAVE");
        } else {
            this.setState({
                accountCategory: ''
            });
        }

    }

    handleAccountCategory = (selectedOption) => {
        this.setState({
            accountCategory: selectedOption
        });
        // console.log("aaaa=========== " + selectedOption)
        if (selectedOption != null) {
            this.loadCategoryData(selectedOption.value, "CODE", "SAVE");
            this.loadAccountCategoryRefNo(selectedOption.value)
            this.loadMainAccount(selectedOption.value)
        } else {
            this.setState({
                accountCategoryName: ''
            });
        }

    }

    handleAccountType = (selectedOption) => {
        this.setState({
            accountType: selectedOption
        });
        if (selectedOption != null) {
            this.loadAccountCategory(selectedOption.value)
        }


    }

    handleAccountCategoryNameEdit = (selectedOption) => {

        this.setState({
            accountCategoryNameEdit: selectedOption
        });
        if (selectedOption != null) {
            this.loadCategoryData(selectedOption.value, "NAME", "EDIT");
            this.setState({
                accountCategoryNameEditValue: selectedOption.value
            });
        } else {
            this.setState({
                accountCategoryEdit: '',
                accountCategoryEditValue: '',
                accountCategoryNameEditValue: '',
            });
        }

    }

    handleAccountCategoryEdit = (selectedOption) => {
        this.setState({
            accountCategoryEdit: selectedOption
        });
        // console.log("aaaa=========== " + selectedOption)
        if (selectedOption != null) {
            this.loadCategoryData(selectedOption.value, "CODE", "EDIT");
            this.loadAccountCategoryRefNo(selectedOption.value)
            this.setState({
                accountCategoryEditValue: selectedOption.value
            });
        } else {
            this.setState({
                accountCategoryNameEdit: '',
                accountCategoryEditValue: '',
                accountCategoryNameEditValue: '',
            });
        }

    }

    handleAccountTypeEdit = (selectedOption) => {
        this.setState({
            accountTypeEdit: selectedOption
        });
        if (selectedOption != null) {
            this.loadAccountCategory(selectedOption.value)
        }


    }


    loadCategoryData(value, type, state) {
        // alert(value)

        if (type == "CODE") {
            const categoryObj = {
                id: value
            }
            // axios.post('http://localhost:5009/accountCategory/getAccountCategoryNameById', categoryObj)
            axios.post(window.accountServer + '/accountCategory/getAccountCategoryNameById', categoryObj)
                .then(response => {
                    // alert(response.data.accountCategories[0].NAME)
                    if (state == "SAVE") {
                        this.setState({
                            accountCategoryName: response.data.accountCategories[0].NAME,
                            category_name_disabled: true
                        });
                    } else {
                        // alert(state)
                        this.setState({
                            accountCategoryNameEdit: response.data.accountCategories[0].NAME,
                            accountCategoryNameEditValue: response.data.accountCategories[0].NAME,
                            category_name_disabled: true
                        });
                    }

                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        } else {
            const categoryObj = {
                name: value
            }
            // axios.post('http://localhost:5009/accountCategory/getAccountCategoryCodeByName', categoryObj)
            axios.post(window.accountServer + '/accountCategory/getAccountCategoryCodeByName', categoryObj)
                .then(response => {

                    // alert(response.data.accountCategories[0].ID_ACCOUNT_CATEGORY)
                    if (state == "SAVE") {
                        this.setState({
                            accountCategory: response.data.accountCategories[0].ID_ACCOUNT_CATEGORY,
                            category_code_disabled: true

                        });
                        this.loadMainAccount(response.data.accountCategories[0].ID_ACCOUNT_CATEGORY)
                    } else {
                        // alert(state)
                        this.setState({
                            accountCategoryEdit: response.data.accountCategories[0].ID_ACCOUNT_CATEGORY,
                            accountCategoryEditValue: response.data.accountCategories[0].ID_ACCOUNT_CATEGORY,
                            category_code_disabled: true
                        });
                        this.loadMainAccount(response.data.accountCategories[0].ID_ACCOUNT_CATEGORY)
                    }
                    this.loadAccountCategoryRefNo(response.data.accountCategories[0].ID_ACCOUNT_CATEGORY)


                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }

    }








    handleCheckControlAccount = name => event => {
        // alert(event.target.checked )
        this.setState({ [name]: event.target.checked });
        if (event.target.checked) {
            // alert("1"+event.target.checked )
            this.setState({
                shown: true
            });
        } else {
            // alert("2"+event.target.checked )
            this.setState({
                shown: false,
                mainAccRef: '',
                mainAccName: ''
            });
        }
    };

    handleCheckControlAccountedit = name => event => {
        // alert(event.target.checked )
        this.setState({ [name]: event.target.checked });
        if (event.target.checked) {
            // alert("1"+event.target.checked )
            this.setState({
                shownEdit: true
            });
        } else {
            // alert("2"+event.target.checked )
            this.setState({
                shownEdit: false
            });
        }
    };

    handleCheckActiveChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChangeEdit = name => event => {
        this.setState({ [name]: event.target.checked });
    };


    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };



    transactionAvailable(ledgerId) {
        const ledgerObj = {
            id: ledgerId
        }
        // axios.post('http://localhost:5009/ledgerAccount/getTrasactionsByLedgerId', ledgerObj)
        axios.post(window.accountServer + '/ledgerAccount/getTrasactionsByLedgerId', ledgerObj)
            .then(response => {
                // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
                // alert(response.data.count[0].COUNT)
                let count = response.data.count[0].COUNT;
                if (count == 0) {
                    this.setState({
                        editAccountType: false,
                        editCatCode: false,
                        editCatName: false,
                        editBankName: false,
                        editBankRefId: false,
                        editControllAcc: false,
                        // isNew: true
                    })

                } else {
                    this.setState({
                        editAccountType: true,
                        editCatCode: true,
                        editCatName: true,
                        editBankName: true,
                        editBankRefId: true,
                        editControllAcc: true,
                        isNew: false
                    })
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    onEdit = (model) => {
        // const ledgerObj = {
        //     id: model.id
        // }
        // axios.post('http://localhost:5009/ledgerAccount/getTrasactionsByLedgerId', ledgerObj)
        //     // axios.post(window.accountServer + '/ledgerAccount/getTrasactionsByLedgerId', ledgerObj)
        //     .then(response => {
        //         // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
        //         // alert(response.data.count[0].COUNT)
        //         let count = response.data.count[0].COUNT;

        //         if (count == 0) {

        //             this.updateLedgerAccount(model);
        //         } else {
        //             this.props.alert.error("can't edit because already have trascation record from this ledger account");
        //         }

        //     }).catch(function (error) {
        //         console.log("err " + error);
        //         console.log("No internet connection or Internal error");
        //         // alert("No internet connection or Internal error");
        //     });

        if (this.state.iscontrolAccountEdit) {
            // alert(this.state.mainAccRefEditValue)
            if (this.state.mainAccRefEditValue == '') {
                this.props.alert.error("Select main account referance number");
            } else {
                this.updateLedgerAccount(model);
            }
        } else {
            this.updateLedgerAccount(model);
        }



    };

    updateLedgerAccount(model) {
        var account_type_id;
        var accountType;
        var mainAccRef = this.state.mainAccRefEditValue;
        var mainAccName = this.state.mainAccNameEditValue;

        var accountCategory = this.state.accountCategoryEditValue;
        var accountCategoryName = this.state.accountCategoryNameEditValue;
        var ledgerAccountEditObj;
        let ledger_ref = model.ledger_refNo_edit;

        if (this.state.accountTypeEdit.value == null) {
            account_type_id = this.state.accountTypeEdit;
            accountType = this.state.accountTypeNameEdit;
        } else {
            account_type_id = this.state.accountTypeEdit.value;
            accountType = this.state.accountTypeEdit.label;
        }



        // if (this.state.mainAccRefEdit == null) {
        //     mainAccRef = this.state.mainAccRefEdit;
        // } else {
        //     mainAccRef = this.state.mainAccRefEdit.value;
        // }

        // if (this.state.mainAccNameEdit == null) {
        //     alert()
        //     mainAccName = this.state.mainAccNameEdit;
        // } else {
        //     mainAccName = this.state.mainAccNameEdit.label;
        // }







        // if (this.state.accountCategoryEdit == null) {
        //     alert("1"+JSON.stringify(this.state.accountCategoryNameEdit) )
        //     accountCategory = this.state.accountCategoryEdit;
        //     accountCategoryName = this.state.accountCategoryNameEdit.value;
        // } else {
        //     alert("2"+JSON.stringify(this.state.accountCategoryNameEdit) )
        //     accountCategoryName = this.state.accountCategoryNameEdit;
        //     accountCategory = this.state.accountCategoryEdit.value;
        // }


        if (this.state.iscontrolAccountEdit) {
            ledger_ref = mainAccRef;
            // alert("kokoko")
            if (mainAccRef == null) {
                this.setState({
                    isNew: false
                })
            } else {
                this.setState({
                    isNew: true
                })
            }
        } else {
            // alert("etet")
            let category_ref = this.state.category_ref_no_edit
            ledger_ref = category_ref + '000';
            mainAccRef = ''
            mainAccName = ''
            if (this.state.category_ref_no_edit == '') {
                this.setState({
                    isNew: false
                })
            } else {
                if (this.state.category_ref_no_edit == this.state.category_ref_no) {
                    this.setState({
                        isNew: false
                    })
                } else {
                    this.setState({
                        isNew: true
                    })
                }

            }
            // alert("false" + ledger_ref)
        }

        if (this.state.isNew) {
            ledgerAccountEditObj = {
                account_type_id: account_type_id,
                accountType: accountType,
                accountCategory: accountCategory,
                main_account_id: this.state.main_account_id,
                ledger_name: model.ledger_name_edit,
                accountCategoryName: accountCategoryName,
                mainAccRef: mainAccRef,
                mainAccName: mainAccName,
                ledger_code: model.ledger_code_edit,
                ledger_refNo: ledger_ref,
                description: model.description_edit,
                is_active: this.state.isActiveEdit,
                id: model.id,
                isNew: this.state.isNew
            }

            console.log(ledgerAccountEditObj)

        } else {
            ledgerAccountEditObj = {
                account_type_id: account_type_id,
                accountType: accountType,
                accountCategory: accountCategory,
                // main_account_id: main_account_id,
                main_account_id: this.state.main_account_id,
                ledger_name: model.ledger_name_edit,
                accountCategoryName: accountCategoryName,
                mainAccRef: mainAccRef,
                mainAccName: mainAccName,
                ledger_code: model.ledger_code_edit,
                ledger_refNo: ledger_ref,
                description: model.description_edit,
                is_active: this.state.isActiveEdit,
                id: model.id,
                isNew: this.state.isNew
            }

            console.log(ledgerAccountEditObj)

        }


        // axios.post('http://localhost:5009/ledgerAccount/updateLedgerAccount', ledgerAccountEditObj)
        axios.post(window.accountServer + '/ledgerAccount/updateLedgerAccount', ledgerAccountEditObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success(" Ledger Account Details Updated Successfully.");
                    this.handleCloseEdit();
                    this.loadData();
                } else {
                    // alert('Ivalid Credentials');
                    this.props.alert.error("Error In Ledger Account Update.");
                }

            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });


    }

    onSubmit = (model) => {

        if (this.state.iscontrolAccount) {
            // alert(this.state.mainAccRefValue)
            if (this.state.mainAccRefValue == '') {
                this.props.alert.error("Select main account referance number");
            } else {
                this.saveLedgerAccount(model);
            }
        } else {
            this.saveLedgerAccount(model);
        }

    };

    //////////////////////////////////////////<<start sheyan>>/////////////////////////////////////////////////
    // close bank information dialog 
    closeBankInfoDialog() {
        this.setState({ openBankInfoDialog: false });
    }

    // load conpany banks
    loadCompanyBank() {

        var companyBanks = [];

        axios.get(window.accountServer + '/bank/getBankDetails')
            .then(response => {

                if (0 == response.data.bankDetails.length || undefined == response.data.bankDetails || null == response.data.bankDetails.length) {

                } else {
                    for (let i = 0; i < response.data.bankDetails.length; i++) {

                        companyBanks.push({
                            value: response.data.bankDetails[i].ID_BANK_ACCOUNT,
                            label: response.data.bankDetails[i].BANK_NAME
                        });
                    }
                    this.setState({
                        companyBanks: companyBanks
                    });
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    handleCompanyBanks = (selectedOption) => {

        if (selectedOption != null) {
            this.setState({ companyBank: selectedOption });
            this.loadCompanyBankAccountNumbers(selectedOption);
        } else {
            this.setState({ companyBank: '' });
            this.setState({ companyBankAccount: '' });
            this.clearBankAccountDetailVals();
        }

    }

    // load bank account numbers 
    loadCompanyBankAccountNumbers(bankName) {
        var companyBankAccNumbers = [];

        var bank = {
            bankName: bankName.label
        };

        axios.post(window.accountServer + '/bank/getBankAccountNumbers', bank)
            .then(response => {

                if (0 == response.data.bankAccNos.length) {

                } else {
                    for (let i = 0; i < response.data.bankAccNos.length; i++) {

                        companyBankAccNumbers.push({
                            value: response.data.bankAccNos[i].ACCOUNT_NO,
                            label: response.data.bankAccNos[i].ACCOUNT_NO
                        });
                    }
                    this.setState({
                        companyBankccountNumbers: companyBankAccNumbers
                    });
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    handleCompanyBankAccounts = (selectedOption) => {

        if (selectedOption != null) {
            this.setState({ companyBankAccount: selectedOption });
            this.loadBankDetailWhereAccountNo(selectedOption);
        } else {
            this.setState({ companyBankAccount: '' });
            this.clearBankAccountDetailVals();
        }

    }

    // load bank detail where given account account no
    loadBankDetailWhereAccountNo(accountNo) {
        // this.setState({ loading: true });

        var accountNoObj = {
            accountNo: accountNo.label
        };

        axios.post(window.accountServer + '/bank/getBankDetailWhereAccountNumber', accountNoObj)
            .then(response => {

                if (0 == response.data.bankDetail.length || null == response.data.bankDetail || undefined == response.data.bankDetail) {

                    this.props.alert.error("No any bank details for this account no");
                    // this.setState({ loading: false });
                } else {

                    this.setState({ bankRoutineNo: response.data.bankDetail[0].ROUTING_NO });
                    this.setState({ branchName: response.data.bankDetail[0].BRANCH });
                    this.setState({ branchCode: response.data.bankDetail[0].BRANCH_CODE });
                    this.setState({ bankAddress1: response.data.bankDetail[0].BANK_ADDRESS1 });
                    this.setState({ bankAddress2: response.data.bankDetail[0].BANK_ADDRESS2 });
                    this.setState({ country: response.data.bankDetail[0].COUNTRY });
                    this.setState({ state: response.data.bankDetail[0].STATE });
                    this.setState({ city: response.data.bankDetail[0].CITY });
                    this.setState({ zipCode: response.data.bankDetail[0].ZIP_CODE });
                    this.setState({ accTypeBank: response.data.bankDetail[0].ACCOUNT_TYPE });
                    this.setState({ accountHolderName: response.data.bankDetail[0].ACCOUNT_HOLDER_NAME });
                    this.setState({ jointAccountHolderName: response.data.bankDetail[0].JOINT_ACCOUNT_HOLDER_NAME });

                    if (1 == response.data.bankDetail[0].IS_ACTIVE) {
                        this.setState({ isActiveBank: true });
                    } else {
                        this.setState({ isActiveBank: false });
                    }

                    // this.setState({ loading: false });
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    // claer bank account detail values
    clearBankAccountDetailVals() {

        this.setState({ bankRoutineNo: '' });
        this.setState({ branchName: '' });
        this.setState({ bankAddress1: '' });
        this.setState({ bankAddress2: '' });
        this.setState({ country: '' });
        this.setState({ state: '' });
        this.setState({ city: '' });
        this.setState({ zipCode: '' });
        this.setState({ accTypeBank: false });
        this.setState({ jointAccountHolderName: '' });
        this.setState({ isActiveBank: false });
    }

    onSubmitBankInfo = (model) => {
        this.saveBankInfromation();
    }

    // save bank infomation
    saveBankInfromation() {

        this.setState({ loading: true });
        var bankInfoObj = {
            ledgerAccountNo: this.state.ledgerAccIdInsereted,
            accountNo: this.state.companyBankAccount.label
        };

        axios.post(window.accountServer + '/bank/updateBankInformation', bankInfoObj)
            .then(response => {

                if (response.data.success) {

                    this.setState({ openBankInfoDialog: false });
                    this.props.alert.success("Bank information saved successfully");
                    this.setState({ loading: false });
                } else {

                    this.props.alert.error("Cannot save bank information !");
                    this.setState({ loading: false });
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.setState({ loading: false });
                // alert("No internet connection or Internal error");
            });
    }

    //////////////////////////////////////<<sheyan>>///////////////////////////////////////////////////////

    saveLedgerAccount(model) {

        var accountCategory;
        var accountCategoryName;
        var mainAccountRef = this.state.mainAccRefValue;
        var mainAccountName = this.state.mainAccNameValue;
        let ledger_ref;

        // alert(this.state.accountCategoryName)
        if (this.state.accountCategory.value == null) {
            accountCategory = this.state.accountCategory;
            accountCategoryName = this.state.accountCategoryName.value;
        } else {
            accountCategoryName = this.state.accountCategoryName;
            accountCategory = this.state.accountCategory.value;
        }

        // if (this.state.mainAccRef.value == null) {
        //     mainAccountRef = this.state.mainAccRef;
        //     mainAccountName = this.state.mainAccName.value;
        // } else {
        //     mainAccountName = this.state.mainAccName;
        //     mainAccountRef = this.state.mainAccRef.value;
        // }

        if (this.state.iscontrolAccount) {
            ledger_ref = mainAccountRef;
            // alert("true" + ledger_ref);
        } else {
            let category_ref = this.state.category_ref_no
            ledger_ref = category_ref + '000';
            mainAccountName = '';
            mainAccountRef = '';
            // alert("false" + ledger_ref)
        }

        const ledgerAccountObj = {
            account_type_id: this.state.accountType.value,
            accountType: this.state.accountType.label,
            accountCategory: accountCategory,
            main_account_id: this.state.main_account_id,
            ledger_name: model.ledger_name,
            accountCategoryName: accountCategoryName,
            // mainAccRef: this.state.mainAccRef.value,
            // mainAccName: this.state.mainAccName.label,
            mainAccRef: mainAccountRef,
            mainAccName: mainAccountName,
            ledger_code: model.ledger_code,
            ledger_refNo: ledger_ref,
            description: model.description,
            is_active: this.state.isActive
        }

        bankInfoLedgerCode = model.ledger_code;
        console.log(ledgerAccountObj)

        // axios.post('http://localhost:5009/ledgerAccount/createLedgerAccount', ledgerAccountObj)
        axios.post(window.accountServer + '/ledgerAccount/createLedgerAccount', ledgerAccountObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success("Ledger Account Details added Successfully.");

                    this.setState({ ledgerAccIdInsereted: res.data.insertId });

                    if ("BANK MAIN ACCOUNT" == this.state.mainAccName.value) {
                        this.setState({ openBankInfoDialog: true });

                        this.loadData();
                        this.closeNewCustomerDialog();
                        // this.clearValue();

                    } else {

                        this.loadData();
                        this.closeNewCustomerDialog();
                        this.clearValue();
                    }

                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            })
    }

    clearValue = () => {
        // alert()
        this.form.reset();
        this.setState({
            shown: false,
            iscontrolAccount: false,
            accountType: '',
            accountCategory: '',
            accountCategoryName: '',
            mainAccRef: '',
            mainAccName: ''
        });
    }

    loadData() {
        var resObj;
        // axios.get('http://localhost:5009/ledgerAccount/getLedgerAccountDetails')
        axios.get(window.accountServer + '/ledgerAccount/getLedgerAccountDetails')
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.ledgerAccountDetails;
                    console.log(resObj)
                    this.appendToTable(resObj)
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        // this.closeNewCustomerDialog();
    }



    appendToTable(ledgerObj) {

        console.log(ledgerObj)
        var data = [];
        var active;
        for (var i = 0; i < ledgerObj.length; i++) {
            if (ledgerObj[i].IS_ACTIVE == 1) {
                active = 'Active'
            } else {
                active = 'Inactive'

            }
            data.push({
                update_id: ledgerObj[i].ID_LEDGER_ACCOUNT,
                // id: "B-" + ledgerObj[i].ID_LEDGER_ACCOUNT,
                accountType: ledgerObj[i].ACCOUNT_TYPE,
                accountTypeId: ledgerObj[i].ID_ACCOUNT_TYPE,
                accountCategory: ledgerObj[i].ACCOUNT_CATEGORY_NAME,
                accountCategoryRefNo: ledgerObj[i].ID_ACCOUNT_CATEGORY,
                mainAccountefNo: ledgerObj[i].MAIN_ACCOUNT_REF_NO,
                mainAccountName: ledgerObj[i].MAIN_ACCOUNT_NAME,
                ledgerefNo: ledgerObj[i].LEDGER_REF_NO,
                ledgerName: ledgerObj[i].NAME,
                description: ledgerObj[i].DESCRIPTION,
                ledgerCode: ledgerObj[i].LEDGER_CODE,
                is_active: ledgerObj[i].IS_ACTIVE,
                mainAccountId: ledgerObj[i].ID_MAIN_ACCOUNT,
                active: active
            });

        }

        this.setState({ data: data });
        this.setState({ loading: false });
    }


    componentWillMount() { }

    render() {
        const { classes } = this.props;

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8">
                                                            
                    <Toolbar className="flex w-full pt-24 px-12 ml-1920 ledger-margin">
                        <h2 className="w-full">
                        <h2 className="subtitle-color">Create Ledger Account</h2>
                        </h2>
                        <div className="px-12">
                            <Button
                                className="w-160"
                                type="button"
                                variant="raised"
                                color="secondary"
                                onClick={(ev) => {
                                    this.openNewCustomerDialog();
                                }}
                            >
                                Add Ledger
                                </Button>
                        </div>
                        <div className="px-12">
                            <Button
                                variant="raised"
                                color="default"
                            >
                                Help
                            </Button>
                        </div>
                    </Toolbar>

                    {/* create bank information dialog <<sheyan>> */}
                    <Dialog className={classNames(classes.root, "z-10")} open={this.state.openBankInfoDialog} fullWidth maxWidth="md">
                        <AppBar className="flex w-full h-50 app-bar-size" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    Bank Information
                          </Typography>
                                <IconButton className="" color="inherit" onClick={this.closeBankInfoDialog} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <DialogContent>
                            <div >
                                <Formsy
                                    onValidSubmit={this.onSubmitBankInfo}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center"
                                >

                                 <fieldset className="mt-8 mr-16  p-8 pb-16">
                                    <div className="flex flex-wrap -mx-3 mb-6 ">
                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24 "
                                            name="ledgerCode"
                                            label="Ledger Code"
                                            value={bankInfoLedgerCode}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            name="ledgerRefNo"
                                            label="Ledger Ref.No"
                                            value={this.state.mainAccRef}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            name="ledgerName"
                                            label="Ledger Name"
                                            value={this.state.mainAccName}
                                            disabled
                                        />
                                    </div>

                                    <Divider />

                                    <div className="flex flex-wrap -mx-3 mb-6">
                                        <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                            Bank Name
                                        <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Bank Name"
                                                value={this.state.companyBank}
                                                onChange={this.handleCompanyBanks}
                                                options={this.state.companyBanks}
                                            />
                                        </div>

                                        <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                            Account Number
                                        <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Account No"
                                                value={this.state.companyBankAccount}
                                                onChange={this.handleCompanyBankAccounts}
                                                options={this.state.companyBankccountNumbers}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-wrap -mx-3 mb-6">
                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            name="bankRoutineNo"
                                            label="Bank Routine No"
                                            value={this.state.bankRoutineNo}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            name="branchName"
                                            label="Branch No"
                                            value={this.state.branchName}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            name="branchCode"
                                            label="Branch Code"
                                            value={this.state.branchCode}
                                            disabled
                                        />

                                    </div>

                                    <div className="flex flex-wrap -mx-3 mb-6">
                                        <TextFieldFormsy
                                            className="w-full md:w-1/2 pr-24"
                                            name="bankAddress1"
                                            label="Bank Address 1"
                                            value={this.state.bankAddress1}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/2 pr-24"
                                            name="bankAddress2"
                                            label="Bank Address 2"
                                            value={this.state.bankAddress2}
                                            disabled
                                        />

                                    </div>

                                    <div className="flex flex-wrap -mx-3 mb-6">
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            name="country"
                                            label="Country"
                                            value={this.state.country}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            name="state"
                                            label="State"
                                            value={this.state.state}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            name="city"
                                            label="City"
                                            value={this.state.city}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            name="zipCode"
                                            label="Zip Code"
                                            value={this.state.zipCode}
                                            disabled
                                        />

                                    </div>

                                    <div className="flex flex-wrap -mx-3 mb-6">
                                        <TextFieldFormsy
                                            className="w-full md:w-1/2 pr-24"
                                            name="accountHolderName"
                                            label="Account Holder's Name"
                                            value={this.state.accountHolderName}
                                            disabled
                                        />
                                        <div className="w-full md:w-1/2">
                                            <label className="ml-24 text-lg">
                                                <input className="w-16 h-16" type="radio" name="searchType" value="Saving" checked={this.state.accTypeBank === 'Saving'} />Saving</label>
                                            <label className="md:w-1/3 ml-24 text-lg">
                                                <input className="w-16 h-16 mt-32" type="radio" name="searchType" value="Current" checked={this.state.accTypeBank === 'Current'} />Current</label>
                                            <label className="md:w-1/3 ml-24 text-lg">
                                                <input className="w-16 h-16 mt-32" type="radio" name="searchType" value="Joint" checked={this.state.accTypeBank === 'Joint'} />Joint</label>
                                        </div>
                                    </div>
                                    <Divider />

                                    <label>If Joint</label>

                                    <TextFieldFormsy
                                        className="w-full md:w-1/2 pr-24"
                                        name="jointAccountHolderName"
                                        label="Joint Account Holder's Name"
                                        value={this.state.jointAccountHolderName}
                                        disabled
                                    />

                                    <div className="block">
                                        <Checkbox
                                            checked={this.state.isActiveBank}
                                            // onChange={this.handleCheckActiveChange('isActive')}
                                            disabled
                                            color="primary"
                                        />
                                        Active
                                    </div>

                                    <div className="w-full md:w-2/3">

                                    </div>

                                     
                                     <div className="mt-16 ">
                                        <Button variant="raised" color="secondary" className="mx-16 mt-16 pb-15" aria-label="Save" type="submit"
                                        //disabled={!canSubmit}
                                        >
                                            Save
                                        </Button>

                                        <Button variant="raised" color="primary" className="mx-16 mt-16 pb-15" aria-label="Clear" onClick={this.clearBankAccountDetailVals}
                                        >
                                            Clear
                                        </Button>

                                        <Button variant="raised" color="primary" className="mx-16 mt-16 pb-15" aria-label="Help"
                                        >
                                            Help
                                        </Button>
                                        </div>
                                   
                                   </fieldset>
                                </Formsy>
                            </div>
                        </DialogContent>
                    </Dialog>


                    <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="md">
                        <AppBar className="flex w-full h-50 app-bar-size" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    Add New Ledger
                          </Typography>
                                <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <Formsy
                            onValidSubmit={this.onSubmit}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            ref={(form) => this.form = form}
                            className="flex flex-col justify-center "
                        >
                            <fieldset className="mt-8 mr-16  p-8 pb-16 ">
                                <div className="block">
                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                        Account Type
                                <Select
                                            className=""
                                            name="form-field-name"
                                            placeholder="Account Type"
                                            value={this.state.accountType}
                                            onChange={this.handleAccountType}
                                            options={this.state.accountTypes}
                                        // value={}
                                        // onChange={}
                                        // options={}
                                        />
                                    </div>
                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                        Account Category Code
                                <Select
                                            className=""
                                            name="form-field-name"
                                            placeholder="Account Category"
                                            // disabled={this.state.category_code_disabled}
                                            value={this.state.accountCategory}
                                            onChange={this.handleAccountCategory}
                                            options={this.state.accountCategories}
                                        // value={}
                                        // onChange={}
                                        // options={}
                                        />
                                    </div>
                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                        Account Category Name
                                <Select
                                            className=""
                                            name="form-field-name"
                                            placeholder="Account Category Name"
                                            // disabled={this.state.category_name_disabled}
                                            value={this.state.accountCategoryName}
                                            onChange={this.handleAccountCategoryName}
                                            options={this.state.accountCategoryNames}
                                        // value={}
                                        // onChange={}
                                        // options={}
                                        />
                                    </div>
                                </div>
                                <div className="block">
                                    <Checkbox
                                        checked={this.state.iscontrolAccount}
                                        onChange={this.handleCheckControlAccount('iscontrolAccount')}
                                        color="primary"
                                    />
                                    Control Account
                        </div>

                                {
                                    this.state.shown
                                        ?
                                        <div>
                                            <Divider />
                                            <div className="block mt-8">
                                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                                    Main Account Ref. No
                                                    <Select
                                                        className=""
                                                        name="form-field-name"
                                                        placeholder="Main Account Ref. No"
                                                        value={this.state.mainAccRef}
                                                        onChange={this.handleMainAccountRef}
                                                        options={this.state.mainAccRefs}
                                                    // value={}
                                                    // onChange={}
                                                    // options={}
                                                    />
                                                </div>
                                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                                    Main Account Name
                                                    <Select
                                                        className=""
                                                        name="form-field-name"
                                                        placeholder="Main Account Name"
                                                        value={this.state.mainAccName}
                                                        onChange={this.handleMainAccountName}
                                                        options={this.state.mainAccountNames}
                                                    // value={}
                                                    // onChange={}
                                                    // options={}
                                                    />
                                                </div>
                                            </div>
                                            <Divider className=" mt-16" />
                                        </div>

                                        : null

                                }


                                <div className="block mt-8">
                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                        <div className="block" >Ledger Name *</div>
                                        <TextFieldFormsy
                                            className="block"
                                            id="ledger_name"
                                            name="ledger_name"
                                            required
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block ledger-textfeild-space">
                                        <div className="block" >Ledger Code </div>
                                        <TextFieldFormsy
                                            className="block"
                                            id="mainAccountCode"
                                            name="ledger_code"
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    {/* <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                        <div className="block" >Ledger Ref No </div>
                                        <TextFieldFormsy
                                            className="block"
                                            id="refNo"
                                            name="ledger_refNo"
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div> */}
                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8 ledger-textfeild-space inline-block">
                                        <div className="block" >Description</div>
                                        <TextFieldFormsy
                                            className="block"
                                            id="description"
                                            name="description"
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="block">
                                    <Checkbox
                                        checked={this.state.isActive}
                                        onChange={this.handleCheckActiveChange('isActive')}
                                        disabled
                                        color="primary"
                                    />
                                    Active
                        </div>

                               <DialogActions className="justify-right pl-16">
                                    <Button
                                        variant="raised"
                                        color="secondary"
                                        className="mx-16 mt-16 pb-15"
                                        aria-label="Save"
                                        type="submit"
                                    //disabled={!canSubmit}
                                    >
                                        Save
                            </Button>

                                    <Button
                                        variant="raised"
                                        color="primary"
                                        className="mx-16 mt-16 pb-15"
                                        aria-label="Clear"
                                        onClick={this.clearValue}
                                    //disabled={!canSubmit}
                                    >
                                        Clear
                            </Button>

                                    <Button
                                        variant="raised"
                                        color="primary"
                                        className="mx-16 mt-16 pb-15"
                                        aria-label="Help"
                                    //disabled={!canSubmit}
                                    >
                                        Help
                            </Button>
                                </DialogActions>

                            </fieldset>
                        </Formsy>
                    </Dialog>

                    <ReactTable
                        data={this.state.data}
                        columns={[

                            {
                                Header: "Account Type",
                                className: "justify-start",
                                accessor: "accountType"
                            },
                            {
                                Header: "Account Category Ref No",
                                className: "justify-start",
                                accessor: "accountCategoryRefNo",
                                width: 200
                            },
                            {
                                Header: "Account Category",
                                className: "justify-start",
                                accessor: "accountCategory"
                            },
                            {
                                Header: "Main Account Ref No",
                                className: "justify-start",
                                accessor: "mainAccountefNo"
                            },
                            {
                                Header: "Main Account Name",
                                className: "justify-start",
                                accessor: "mainAccountName"

                            },
                            {
                                Header: "Ledger Ref No",
                                className: "justify-start",
                                accessor: "ledgerefNo"

                            },
                            {
                                Header: "Ledger Name",
                                className: "justify-start",
                                accessor: "ledgerName"

                            },
                            {
                                Header: "Status",
                                accessor: "status",
                                maxWidth: 200,
                                className: "justify-center",
                                Cell: row => (

                                    <div className="flex items-center">
                                        <Icon
                                            className={row.original.active === 'Active' ? 'text-green-light'
                                                : row.original.active === 'Inactive' ? 'text-red-light'
                                                    : 'text-orange-light'}
                                            title={row.original.active === 'Active' ? 'Active'
                                                : row.original.active === 'Inactive' ? 'Inactive'
                                                    : 'text-orange-light'}
                                        >
                                            {row.original.active === 'Active' ? 'check_circle'
                                                : row.original.active === 'Inactive' ? `cancel`
                                                    : 'Other'}
                                        </Icon>

                                    </div>
                                )

                            },
                            {
                                Header: "Action",
                                maxWidth: 100,
                                className: "justify-center",
                                // accessor: "su",
                                width: 128,
                                Cell: row => (
                                    <div className="flex items-center w-8 h-8">
                                        <IconButton

                                            onClick={(e) => {
                                                if (row) {
                                                    // alert(row.original.accountType)
                                                    id = row.original.update_id;
                                                    accountType = row.original.accountType;
                                                    accountTypeId = row.original.accountTypeId;
                                                    accountCategory = row.original.accountCategory;
                                                    accountCategoryRefNo = row.original.accountCategoryRefNo;
                                                    mainAccountefNo = row.original.mainAccountefNo;
                                                    mainAccountName = row.original.mainAccountName;
                                                    ledgerefNo = row.original.ledgerefNo;
                                                    ledgerName = row.original.ledgerName;
                                                    description = row.original.description;
                                                    ledgerCode = row.original.ledgerCode;
                                                    is_active = row.original.is_active;
                                                    mainAccountId = row.original.mainAccountId;

                                                    if (mainAccountefNo == null || mainAccountName == null) {
                                                        this.setState({
                                                            iscontrolAccountEdit: false,
                                                            shownEdit: false
                                                        });
                                                    } else {
                                                        this.setState({
                                                            iscontrolAccountEdit: true,
                                                            shownEdit: true
                                                        });
                                                    }
                                                    this.setState({loading:true});

                                                    this.loadAccountCategory(accountTypeId)
                                                    this.transactionAvailable(id)
                                                    this.loadAccountCategoryRefNoEdit(accountCategoryRefNo)
                                                    this.loadMainAccount(accountCategoryRefNo)
                                                    // alert(accountCategory)

                                                    this.setState({
                                                        category_ref_no: '',
                                                        accountTypeEdit: accountTypeId,
                                                        accountTypeNameEdit: accountType,
                                                        accountCategoryEdit: accountCategoryRefNo,
                                                        accountCategoryNameEdit: accountCategory,
                                                        accountCategoryEditValue: accountCategoryRefNo,
                                                        accountCategoryNameEditValue: accountCategory,
                                                        mainAccRefEdit: mainAccountefNo,
                                                        mainAccNameEdit: mainAccountName,
                                                        mainAccRefEditValue: mainAccountefNo,
                                                        mainAccNameEditValue: mainAccountName,
                                                        mainAccountId: mainAccountId,
                                                        main_account_id: mainAccountId,
                                                        mainAccountNameChange: mainAccountName
                                                    });

                                                    this.setState({ isActiveEdit: row.original.is_active });

                                                    this.setState({ edit: true , loading:false});
                                                }
                                                // alert(mainAccountId)
                                            }}

                                        >
                                            <Icon className="text-blue" title="Edit">mode_edit</Icon>
                                        </IconButton>
                                        <Dialog
                                            className={classNames(classes.root, "z-10")}
                                            open={this.state.edit}
                                            onClose={this.handleCloseEdit}
                                            aria-labelledby="form-dialog-title"
                                        >

                                                <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                                    <Toolbar className="flex w-full">
                                                        <Typography className="w-full" variant="subheading" color="inherit">
                                                            Edit Ledger Account Details
                                                  </Typography>
                                                        <IconButton className="" color="inherit" onClick={this.handleCloseEdit} aria-label="Close">
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Toolbar>
                                                </AppBar>
                                            <Formsy
                                                onValidSubmit={this.onEdit}
                                                onValid={this.enableButtonEdit}
                                                onInvalid={this.disableButtonEdit}
                                                ref={(form) => this.form = form}
                                                className=""
                                            >

                                                


                                                <DialogContent className="flex flex-wrap">

                                                    <div className="w-full ">


                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="id"
                                                            value={id}
                                                        />

                                                        <div className="block">
                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                Account Type
                                                                     <Select
                                                                    className=""
                                                                    name="form-field-name"
                                                                    placeholder="Account Type"
                                                                    value={this.state.accountTypeEdit}
                                                                    onChange={this.handleAccountTypeEdit}
                                                                    options={this.state.accountTypes}
                                                                    disabled={this.state.editAccountType}
                                                                // value={}
                                                                // onChange={}
                                                                // options={}
                                                                />
                                                            </div>
                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                Account Category Code
                                                                    <Select
                                                                    className=""
                                                                    name="form-field-name"
                                                                    placeholder="Account Category"
                                                                    // disabled={this.state.category_code_disabled}
                                                                    value={this.state.accountCategoryEdit}
                                                                    onChange={this.handleAccountCategoryEdit}
                                                                    options={this.state.accountCategories}
                                                                    disabled={this.state.editCatCode}
                                                                // value={}
                                                                // onChange={}
                                                                // options={}
                                                                />
                                                            </div>
                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                Account Category Name
                                                                    <Select
                                                                    className=""
                                                                    name="form-field-name"
                                                                    placeholder="Account Category Name"
                                                                    // disabled={this.state.category_name_disabled}
                                                                    value={this.state.accountCategoryNameEdit}
                                                                    onChange={this.handleAccountCategoryNameEdit}
                                                                    options={this.state.accountCategoryNames}
                                                                    disabled={this.state.editCatName}
                                                                // value={}
                                                                // onChange={}
                                                                // options={}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="block">
                                                            <Checkbox
                                                                checked={this.state.iscontrolAccountEdit}
                                                                onChange={this.handleCheckControlAccountedit('iscontrolAccountEdit')}
                                                                color="primary"
                                                                disabled={this.state.editControllAcc}
                                                            />
                                                            Control Account
                                                        </div>

                                                        {
                                                            this.state.shownEdit
                                                                ?
                                                                <div>
                                                                    <Divider />
                                                                    <div className="block mt-8">
                                                                        <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                            Main Account Ref. No
                                                                                <Select
                                                                                className=""
                                                                                name="form-field-name"
                                                                                placeholder="Main Account Ref. No"
                                                                                value={this.state.mainAccRefEdit}
                                                                                onChange={this.handleMainAccountRefEdit}
                                                                                options={this.state.mainAccRefs}
                                                                                disabled={this.state.editBankRefId}
                                                                            // value={}
                                                                            // onChange={}
                                                                            // options={}
                                                                            />
                                                                        </div>

                                                                        <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                            Main Account Name
                                                                                <Select
                                                                                className=""
                                                                                name="form-field-name"
                                                                                placeholder="Main Account Name"
                                                                                value={this.state.mainAccNameEdit}
                                                                                onChange={this.handleMainAccountNameEdit}
                                                                                options={this.state.mainAccountNames}
                                                                                disabled={this.state.editBankName}
                                                                            // value={}
                                                                            // onChange={}
                                                                            // options={}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <Divider className=" mt-16" />
                                                                </div>

                                                                : null

                                                        }


                                                        <div className="block mt-8">
                                                            <div className="w-full sm:w-1/2 md:w-1/2 px-8  inline-block">
                                                                <div className="block" >Ledger Name</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    id="ledger_name"
                                                                    name="ledger_name_edit"
                                                                    value={ledgerName}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                <div className="block" >Ledger Code </div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    id="mainAccountCode"
                                                                    name="ledger_code_edit"
                                                                    value={ledgerCode}
                                                                    className={classes.textField}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="w-full sm:w-1/2 md:w-1/2 px-8  inline-block">
                                                                <div className="block" >Ledger Ref No </div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    id="refNo"
                                                                    name="ledger_refNo_edit"
                                                                    value={ledgerefNo}
                                                                    disabled={true}
                                                                    className={classes.textField}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                <div className="block" >Description</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    id="description"
                                                                    name="description_edit"
                                                                    value={description}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="block">
                                                            <Checkbox
                                                                checked={this.state.isActiveEdit}
                                                                onChange={this.handleCheckActiveChangeEdit('isActiveEdit')}
                                                                color="primary"
                                                            />
                                                            Active
                                                            </div>



                                                    </div>

                                                </DialogContent>
                                                <DialogActions>

                                                     <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8 ">
                                                        Update
                                                                        </Button>
                                                                        
                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                                        Close
                                                                        </Button>

                                                   
                                                </DialogActions>
                                            </Formsy>
                                        </Dialog>
                                    </div>
                                )
                            }
                        ]}
                        //pageSize={this.state.records.length>3?this.state.records.length:3}
                        defaultPageSize={10}
                        className="-striped -highlight"
                    />
                </div>
            )


        }
    }

    handleSaveClick() {
        console.log('Save pre validations billdate', this.state.billDate);
        var billDate;
        /* if(this.state.billDate==''){
                            billDate = moment(new Date()).format("YYYY-MM-DD");
                        }else{
                            billDate = this.state.billDate
                        } */
        if (this.state.billDate == undefined) {

            confirmAlert({
                title: 'Bill Date', message: 'Select a valid bill date',
                buttons: [{ label: 'Ok' }]
            })
            return;
        }


        var discountGiven = this.state.sumValues.isDiscountPercentage ?
            parseFloat(this.state.sumValues.grossAmount) * parseFloat(this.state.sumValues.discount) / 100
            : this.state.sumValues.discount;

        if (this.state.customerPrivilageDiscount && parseFloat(parseFloat(this.state.customerPrivilageDiscount).toFixed(2)) < parseFloat(parseFloat(discountGiven).toFixed(2))) {

            confirmAlert({
                title: 'Item price', message: 'Customer discount privilage limit exceeded. Limit is ' + parseFloat(this.state.customerPrivilageDiscount).toFixed(2),
                buttons: [{ label: 'Ok' }]
            })
            return;
        }

        if (this.state.isQuotation) {
            this.createQuotation();
        }
        else {
            this.createInvoice();
        }
    }

}

export default withStyles(styles, { withTheme: true })(withAlert(LedgerAccount));





// WEBPACK FOOTER //
// ./src/main/content/accounting/ledgerAccount/LedgerAccount.js